import { ChevronDown, ChevronUp } from 'lucide-react';
import { useId, useLayoutEffect, useRef, useState } from 'react';
import { getMessageText } from './AssistantProvider';

const UserMessage = ({ message }) => {
    const text = getMessageText(message);
    const textRef = useRef(null);
    const textId = useId();
    const [isExpanded, setIsExpanded] = useState(false);
    const [canExpand, setCanExpand] = useState(false);

    useLayoutEffect(() => {
        const el = textRef.current;
        if (!el || isExpanded) return;
        const measure = () => setCanExpand(el.scrollHeight > el.clientHeight);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, [text, isExpanded]);

    return (
        <div
            className="self-end max-w-[90%] md:max-w-[80%]"
            data-message-role="user"
            data-message-id={message.id}
        >
            <div className="px-3.5 py-2.5 rounded-xl text-sm leading-relaxed bg-[#1B1A2E] text-white rounded-br-sm">
                <div
                    ref={textRef}
                    id={textId}
                    className={`whitespace-pre-wrap break-words ${isExpanded ? '' : 'line-clamp-6'}`}
                >
                    {text}
                </div>
                {canExpand ? (
                    <button
                        type="button"
                        onClick={() => setIsExpanded((prev) => !prev)}
                        aria-expanded={isExpanded}
                        aria-controls={textId}
                        className="mt-1 inline-flex items-center gap-1 text-xs font-medium text-white/70 hover:text-white cursor-pointer"
                    >
                        {isExpanded ? (
                            <>
                                Show less
                                <ChevronUp size={14} />
                            </>
                        ) : (
                            <>
                                Show more
                                <ChevronDown size={14} />
                            </>
                        )}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default UserMessage;
